// extracted by mini-css-extract-plugin
export default {"emptyPage":"EmptyPage_emptyPage__bN3fB","title":"EmptyPage_title__C08Pt","subtitle":"EmptyPage_subtitle__B6XDf"};